import { Icons } from "../components/Icons.js";
import { NotesView } from "../notes/NotesView.js";
import type { EditTarget } from "../notes/types.js";

/** Écran « Mes notes » (mobile) : barre + liste des enregistrements. */
export function NotesScreen({ onOpen, reloadToken, goBack }: { onOpen: (t: EditTarget) => void; reloadToken: number; goBack: () => void }) {
  return (
    <div className="screen notes">
      <header className="topbar">
        <button className="iconbtn" onClick={goBack} aria-label="Retour">
          <Icons.Back size={22} />
        </button>
        <div className="screen-title">Mes notes</div>
        <span style={{ width: 42 }} />
      </header>
      <NotesView onOpen={onOpen} reloadToken={reloadToken} />
    </div>
  );
}
